<template>
  <div>
    <el-radio-group v-model="issue.select">
      <ul>
        <li v-for="item in issue.items" :key="item.id" class="image-choice-box">
          <image-choice-item :item="item" :class="{ checked: issue.select === item.id }">
            <template>
              <adapter-radio :label="item.id" :rich-text="item.content.richText">
                <div v-html="item.content.richText" class="text-theme-black-850 text-medium leading-base" ref="text"></div>
              </adapter-radio>
            </template>
            <template v-slot:vote>
              <vote-progress
                  v-if="showVoteProgress && issue.select"
                  :vote="question.vote"
                  :label="item.id"
                  :checked="issue.select === item.id"
                  :selected="!!issue.select"
              />
            </template>
          </image-choice-item>
        </li>
      </ul>
    </el-radio-group>
  </div>
</template>

<script>
import ImageChoiceItem from '@/questions/components/ImageChoiceItem'
import AdapterRadio from '@/questions/components/Adapter/AdapterRadio'
import VoteProgress from '@/questions/components/VoteProgress.vue'

export default {
  changeExpr: 'issue.select',
  name: 'ImageChoice',
  components: { VoteProgress, AdapterRadio, ImageChoiceItem }
}
</script>
